import { c as _c } from "react/compiler-runtime";
import { Menu01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "@matsuricon/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "@matsuricon/ui/sheet";
import Link from "next/link";
import { useState } from "react";
import { SiteWordmark } from "@/components/site-shell/branding/site-wordmark";
import { MobileNavigation } from "./mobile-navigation";
import type { NavItem } from "./navigation-data";
type MobileNavigationSheetProps = {
  items: readonly NavItem[];
  pathname: string;
};
export function MobileNavigationSheet(t0) {
  const $ = _c(12);
  const {
    items,
    pathname
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const close = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SheetTrigger asChild={true}><Button variant="ghost" size="icon-lg" aria-label="Open navigation menu" className="size-11 xl:hidden"><HugeiconsIcon icon={Menu01Icon} strokeWidth={2} /></Button></SheetTrigger>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SheetHeader className="pr-16"><SheetTitle className="sr-only">Main Navigation</SheetTitle><SheetDescription className="sr-only">Browse Matsuricon pages and registration links.</SheetDescription><SiteWordmark /></SheetHeader>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== items || $[4] !== pathname) {
    t4 = <nav aria-label="Main" className="px-3 pb-4"><MobileNavigation items={items} pathname={pathname} onNavigate={close} /></nav>;
    $[3] = items;
    $[4] = pathname;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SheetFooter className="border-t border-border/70"><Button asChild={true} size="lg" className="h-12 font-sans text-sm tracking-normal"><Link href="/registration/attend" onClick={close}>Register Now</Link></Button></SheetFooter>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <SheetContent side="top" className="max-h-svh overflow-y-auto overscroll-contain border-border bg-popover pt-[env(safe-area-inset-top)] font-sans">{t3}{t4}{t5}</SheetContent>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== open || $[10] !== t6) {
    t7 = <Sheet open={open} onOpenChange={setOpen}>{t2}{t6}</Sheet>;
    $[9] = open;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}